import React from 'react';
import { BUTTON_STYLES } from '../../constants/styles';
import SubstitutionBadge from './SubstitutionBadge';

const GarnishSubstitutionSection = ({ order, orderIndex, onToggleGarnish, isLocked, saving, autoSubstitution }) => {
    if (!order.garnishOptions || order.garnishOptions.length === 0) {
        return null;
    }

    const showAutoSubBadge = autoSubstitution?.addedId &&
        order.garnishOptions.some(opt => opt.id === autoSubstitution.addedId && opt.isActive);

    return (
        <div style={{ marginBottom: '15px' }}>
            <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#555'
            }}>
                Garnish:
                {showAutoSubBadge && (
                    <SubstitutionBadge
                        removedName={autoSubstitution.removedName}
                        addedName={autoSubstitution.addedName}
                    />
                )}
            </label>
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                {order.garnishOptions.map((garnishOption, index) => {
                    const isActive = garnishOption.isActive;
                    const isDisabled = isLocked || saving;

                    return (
                        <button
                            key={index}
                            onClick={() => onToggleGarnish && onToggleGarnish(orderIndex, garnishOption.id, isActive)}
                            disabled={isDisabled}
                            style={BUTTON_STYLES.substitution(isActive, isDisabled)}
                        >
                            <span style={{
                                marginRight: '4px',
                                fontSize: '12px'
                            }}>
                                {isActive ? '✓' : '+'}
                            </span>
                            {garnishOption.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default GarnishSubstitutionSection;